import React from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from './authConfig';

function Login() {
  const { instance } = useMsal();

  const handleLogin = () => {
    instance.loginRedirect(loginRequest).catch(e => {
      console.error(e);
    });
  };

  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <div className="card mt-5">
            <div className="card-body text-center">
              <img 
                src="/images/tactical-logo-trimmed.png" 
                alt="TactiCal Logo" 
                style={{ height: '120px', marginBottom: '30px' }}
              />
              <h2 className="card-title mb-4">Platform Engineering Calendar</h2>
              <p className="card-text mb-4">
                Please sign in with your Microsoft account to access the calendar.
              </p>
              <button 
                className="btn btn-primary btn-lg"
                onClick={handleLogin}
              >
                Sign in with Microsoft
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;